import * as React from 'react';
import * as PropTypes from 'prop-types';
import {
  Header,
  Toggle,
  Title,
  Wrapper,
  SidebarStyled,
  Isotipo,
  Menu,
  Overlay
} from './styled';
import { useToggle } from './hooks/useToggle';
import { useResize } from './hooks/useResize';
import { Item, Props as ItemProps } from './components/Item';

interface Props {
  itemsTop?: ItemProps[];
  itemsBottom?: ItemProps[];
  fixed?: boolean;
  width?: string;
  title?: string;
}

export const Sidebar: React.FC<Props> = ({
  itemsTop,
  itemsBottom,
  fixed,
  width,
  title
}) => {

  const toggle = useToggle();
  const resize = useResize();

  return (
    <>
      <Header>
        <Toggle
          name="menu"
          show={toggle.isOpen}
          onClick={toggle.onClick}
        />
        <Title>{title}</Title>
      </Header>
      <Wrapper width={width} show={toggle.isOpen}>
        <SidebarStyled data-test="navList" fixed={fixed} width={width}>
          <Isotipo data-test="navIsotype" resize={resize}>
            <svg width="51" height="52" viewBox="0 0 144 96" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 48 L48 0 L96 48 L48 96 Z" fill="#111" />
              <path d="M96 0 L144 48 L96 96 Z" fill="#111" />
            </svg>
          </Isotipo>
          <Menu data-test="navMenu">
            <div>
              { itemsTop
                && itemsTop.map((item, index) => <Item key={index} {...item} />)
              }
            </div>
            <div>
              { itemsBottom
                && itemsBottom.map((item, index) => <Item key={index} {...item} />)
              }
            </div>
          </Menu>
        </SidebarStyled>
      </Wrapper>
      <Overlay show={toggle.isOpen} onClick={toggle.onClick} />
    </>
  );
};

Sidebar.propTypes = {
  itemsTop: PropTypes.arrayOf(PropTypes.shape({
    selected: PropTypes.bool,
    icon: PropTypes.object.isRequired,
    tooltip: PropTypes.string,
    onClick: PropTypes.func,
    renderComponent: PropTypes.func
  })),
  itemsBottom: PropTypes.arrayOf(PropTypes.shape({
    selected: PropTypes.bool,
    icon: PropTypes.object.isRequired,
    tooltip: PropTypes.string,
    onClick: PropTypes.func,
    renderComponent: PropTypes.func
  })),
  fixed: PropTypes.bool,
  width: PropTypes.string,
  title: PropTypes.string
};

Sidebar.displayName = 'Sidebar';
